import { ArrowRight, FileText, BookOpen, Wrench, Sparkles, BarChart3 } from 'lucide-react';
import { ARTICLES, COMPANY } from '../data/content';
import SEO from '../components/SEO';

const tagIcons = {
  'Technical Deep Dive': FileText,
  'Research': BarChart3,
  'Application Guide': BookOpen,
  'Machine Guide': Wrench,
  'Loading Chart': BarChart3,
  'Innovation': Sparkles,
  'Speciality': Wrench,
};

export default function KnowledgePage() {
  return (
    <>
      <SEO title="Knowledge Hub" description="Technical articles on textile spinning, drafting loads, spindle concentricity and measurement best practices from Apex Precitech." />
      <div data-testid="knowledge-page" className="pt-16 md:pt-18 min-h-screen">

      {/* ── Header — light ── */}
      <section className="py-14 md:py-16 border-b border-steel-200" style={{ background: '#FAFAF8' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-[2px] bg-safety" />
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-safety">Knowledge Hub</span>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-steel-900 uppercase tracking-tight mb-4">
            Technical Articles
          </h1>
          <p className="text-steel-500 text-base max-w-xl leading-relaxed">
            Deep dives into spinning technology, drafting systems, and measurement best practices.
            Published on our technical blog.
          </p>
        </div>
      </section>

      {/* ── Articles grid ── */}
      <section className="py-10 md:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border border-steel-200">
            {ARTICLES.map((a, i) => {
              const TagIcon = tagIcons[a.tag] || FileText;
              return (
                <a
                  key={i}
                  data-testid={`article-${i}`}
                  href={COMPANY.blog}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group p-7 border-b border-r border-steel-200 hover:bg-orange-50/40 transition-colors duration-200 flex flex-col"
                >
                  <div className="flex items-center gap-2 mb-3">
                    <TagIcon size={12} className="text-safety" strokeWidth={2} />
                    <span className="font-mono text-[10px] uppercase tracking-wider text-steel-400">{a.tag}</span>
                  </div>
                  <h3 className="font-heading text-base uppercase tracking-wide text-steel-900 mb-2 group-hover:text-safety transition-colors leading-tight flex-grow">
                    {a.title}
                  </h3>
                  <p className="text-steel-500 text-sm leading-relaxed mb-4">{a.excerpt}</p>
                  <span className="font-mono text-[10px] uppercase tracking-wider text-steel-300 flex items-center gap-1 group-hover:text-safety transition-colors mt-auto">
                    Read on Blog <ArrowRight size={10} />
                  </span>
                </a>
              );
            })}
          </div>

          <div className="mt-10 text-center">
            <a
              data-testid="knowledge-blog-link"
              href={COMPANY.blog}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-steel-900 text-white font-heading uppercase text-sm tracking-wider px-8 py-3.5 hover:-translate-y-0.5 hover:bg-stone-800 transition-all duration-200"
            >
              Visit Full Blog <ArrowRight size={15} />
            </a>
          </div>
        </div>
      </section>
    </div>
    </>
  );
}